"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m0 10H3V8h18zM6 15h2v-2h2v-2H8V9H6v2H4v2h2z"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "14.5",
  cy: "13.5",
  r: "1.5"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "18.5",
  cy: "10.5",
  r: "1.5"
}, "2")], 'VideogameAssetOutlined');